var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Building Listing\n  "),_c('building-list',{attrs:{"items":_vm.SelectedBatchBuildingList,"allow-item-check":false,"show-batch-status":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }